/**
 * 检查项配置（项目管理）入口（路由 /myse/projects）
 *
 * 当前模块仅一个列表页 + 弹窗（新增/编辑），不存在 list ↔ detail 切换。
 * 所有状态在子组件 hooks 内管理，不依赖 Redux slice。
 */
import React from 'react'
import { Layout } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import List from './List'
import './index.scss'

const { Content } = Layout

const ProjectsPage: React.FC = () => {
  const dispatch = useAppDispatch()
  const reduxState = useAppSelector((state) => state)
  const navigate = useNavigate()

  return (
    <Layout className="projects-page">
      <Content style={{ padding: 24 }}>
        <List
          dispatch={dispatch}
          state={reduxState}
          onGoToDownloads={() => navigate('/myse/downloads')}
        />
      </Content>
    </Layout>
  )
}

export default ProjectsPage
